'use client';

import { Provider as JotaiProvider } from 'jotai';
import { ReactNode, Suspense } from 'react';
import { ThemeProvider } from 'next-themes';
import QueryProvider from './QueryProvider';
import PostHogProvider from './PostHogProvider';
import { AuthGuard } from '@/_components/AuthGuard/AuthGuard';
import { PapiProvider } from './PapiProvider';

function Providers({ children }: { children: ReactNode }) {
	return (
		<ThemeProvider
			attribute='class'
			defaultTheme='dark'
			enableSystem
			disableTransitionOnChange
		>
			<JotaiProvider>
				<QueryProvider>
					<PostHogProvider>
						<PapiProvider>
							<Suspense fallback={null}>
								<AuthGuard>{children}</AuthGuard>
							</Suspense>
						</PapiProvider>
					</PostHogProvider>
				</QueryProvider>
			</JotaiProvider>
		</ThemeProvider>
	);
}

export default Providers;
